import { BookTypeEnum, IBook } from "@/interface/IBook";
import BookCover from "../BookCover";
import styles from "./index.module.scss";
import classNames from "classnames";
import Link from "next/link";
import { formatNumber } from "@/utils/formatTools";
import { composeChapterUrl } from "@/utils/URL";

export type BookCardProps = {
  bookInfo: IBook;
  handleBookLink?: (bookInfo: IBook) => string;
} & React.HTMLAttributes<any>;

const BookCard = (props: BookCardProps) => {
  const { bookInfo, handleBookLink, className, ...restProps } = props;
  const { bookId = "", pvNum = 0, authorName, description } = bookInfo;
  const bookName = bookInfo.bookName ?? bookInfo.name;
  return (
    <Link
      href={
        handleBookLink
          ? handleBookLink(bookInfo)
          : composeChapterUrl({
              bookId,
              bookName: "",
              novelType: BookTypeEnum.Novel,
              isPureId: true,
            })
      }
      className={classNames(styles.container, className)}
      {...restProps}
    >
      <BookCover bookInfo={bookInfo} width={78} className="br4" />
      <div className={styles.content}>
        <h3 className={classNames(styles.name, "ells _2")}>{bookName}</h3>
        <div className={classNames(styles.desc, "ells _3")}>{description}</div>
        <div className={styles.extra}>
          {`${authorName} · ${formatNumber(+pvNum).toUpperCase()} Views`}
        </div>
      </div>
    </Link>
  );
};

export default BookCard;
